<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app>
      <v-list-item color="black">
        <v-list-item-content>
          <v-list-item-title class="text-h6 text-uppercase">
            ipaprévision
          </v-list-item-title>
          <v-list-item-subtitle>
            Outil de gestion prévisionnelle
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <template v-for="item in items">
          <template
            v-if="
              (item.title == 'Admin' && getRoleToken() == 'Admin') ||
                item.title != 'Admin'
            "
          >
            <v-list-item :key="item.title" :to="item.to" link>
              <v-list-item-icon>
                <v-icon large>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
      <div class="pt-2 text-center" v-if="isTokenExist()">
        Connecté avec l'email : {{ getEmailToken() }}
      </div>
      <v-btn class="mx-5 my-10" color="#51bdcb" dark @click="logout()">
        Se déconnecter
      </v-btn>
      <v-btn
        class="mx-5"
        color="success"
        :loading="loading"
        :disabled="loading"
        elevation="2"
        @click="loader = 'loading'"
      >
        Données HANA
      </v-btn>
      <v-tooltip right max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        <span>
          Ce bouton permet de récupérer et mettre à jour les projets existants
          sur HANA et reliés à BoondManager (ID Boond à la création d'un
          projet). Il permet aussi la mise à jour des ressources avec leur état
          actuel. Si ces données existent déjà, elles seront mise à jour en
          écrasant les précédentes.
        </span>
      </v-tooltip>
      <v-col class="caption pl-5">
        <!-- <span>Dernière MàJ : {{ lastUpdate }}</span> -->
      </v-col>
      <template v-if="isErrorMessageDisplayed"> <PopUpError /></template>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>Gestion prévisionnelle de ressources</v-toolbar-title>
      <v-img
        src="./assets/thumbnail_Outlook-stbjr3qz.png"
        max-width="150"
        max-height="250"
        class="ml-auto"
      >
      </v-img>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { UPDATE_BOOND_DATA } from './graphql/GraphQLMutations';

export default {
  data: () => ({
    // lastUpdate: '',
    drawer: null,
    dialog: false,
    loader: null,
    loading: false,
    isErrorMessageDisplayed: false,
    items: [
      { title: 'Projets', icon: 'mdi-calendar-multiple', to: '/projects' },
      { title: 'Ressources', icon: 'mdi-account-supervisor', to: '/resources' },
      { title: 'Admin', icon: 'mdi-cog-outline', to: '/admin' },
    ],
  }),

  watch: {
    async loader() {
      this.isErrorMessageDisplayed = false;
      if (this.loader === 'loading') {
        const l = this.loader;
        this[l] = !this[l];

        await this.$apollo
          .mutate({
            mutation: UPDATE_BOOND_DATA,
          })
          .then(() => {
            // Result
            this[l] = false;
            this.loader = null;
            document.location.reload();
          })
          .catch(() => {
            this[l] = false;
            this.loader = null;
            // Error
            this.isErrorMessageDisplayed = true;
          });
      }
    },
  },

  methods: {
    logout() {
      if (localStorage) {
        localStorage.removeItem('apollo-token');
        this.$router.push('/');
      }
    },
    getEmailToken() {
      const token = localStorage.getItem('apollo-token');
      if (token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64)).email;
      }
      return false;
    },
    getRoleToken() {
      const token = localStorage.getItem('apollo-token');
      if (token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64)).role;
      }
      return false;
    },
    isTokenExist() {
      if (localStorage.getItem('apollo-token')) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
/* -- Scrollbar -- */
/* width */
::-webkit-scrollbar {
  width: 15px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f0f0f0;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #51bdcb;
  border: 2px solid #f0f0f0;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #006989;
}
</style>
